/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".contact-listing__contacts[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}.contact-listing__contact[_ngcontent-%COMP%]{flex:1 1 50%}@media only screen and (max-width:1024px){.contact-listing__contact[_ngcontent-%COMP%]{flex-basis:100%}}"];
export { styles as styles };
